import { Injectable, inject } from '@angular/core';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { Observable, map } from 'rxjs';
import { ExternalCredentialType, ExternalProviderResponse } from '@por/shared/core';

@Injectable({
    providedIn: 'root'
})
export class ExternalProviderService {
    private readonly consumerPortalApiService = inject(ConsumerPortalApiService);

    testHapnConnection(clientId: string, clientSecret: string): Observable<ExternalProviderResponse> {
        /* eslint-disable @typescript-eslint/naming-convention  */
        return this.consumerPortalApiService
            .post<ExternalProviderResponse>({
                controller: `external-credentials/hapn/test`,
                method: 'POST',
                body: {
                    grant_type: 'client_credentials',
                    client_id: clientId,
                    client_secret: clientSecret
                }
            })
            .pipe(
                map(res => {
                    return res;
                })
            ) as unknown as Observable<ExternalProviderResponse>;
    }

    getLivelinkUrl(customerId: string): Observable<{ livelink: string; expiresAt: string }> {
        return this.consumerPortalApiService.post<{ livelink: string; expiresAt: string }>({
            controller: `gps-provider/${customerId}/livelink`,
            method: 'POST',
            body: {
                gpsProvider: ExternalCredentialType.Hapn
            }
        });
    }
}
